import type { IAiWorkflow } from '@torim-app/types';
import { adminUrlBuilder } from '@app/api/utils';

export class AiWorkflowsApi {
  static path = 'ai-workflows';

  static async list(): Promise<IAiWorkflow[]> {
    const url = adminUrlBuilder({}, AiWorkflowsApi.path);
    const response = await fetch(url, {
      method: 'get',
      headers: { 'content-type': 'application/json' },
    });
    if (response.status >= 400) throw 'Failed to fetch AI workflows';
    return await response.json();
  }

  static async upsert(workflow: IAiWorkflow): Promise<IAiWorkflow> {
    const url = adminUrlBuilder({}, AiWorkflowsApi.path);
    const response = await fetch(url, {
      method: 'post',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(workflow),
    });
    if (response.status >= 400) throw 'Failed to save AI workflow';
    return await response.json();
  }

  static async remove(id: string): Promise<void> {
    const url = adminUrlBuilder({}, `${AiWorkflowsApi.path}/${id}`);
    const response = await fetch(url, {
      method: 'delete',
      headers: { 'content-type': 'application/json' },
    });
    if (response.status >= 400) throw 'Failed to delete AI workflow';
  }
}
